<template>
  <div>
    <div class="page-header bordered">
      <h1>Analytics Integration</h1>
    </div>

    <form>
      <ShowErrors
        :errorMessages="errorMessages"
      />

      <div class="row" v-for="(analyticReference, index) in availableAnalytics" :key="index">
        <div class="col-lg-6">
          <div class="form-group">
            <label :for="analyticReference">
              <img :src="require('../../../assets/img/analytic_icons/' + analyticReference + '.png')"
                width="20" height="20" />
              {{ camelize(analyticReference, '_') }}
            </label>
            <input type="text" v-model.trim="analytic['data'][analyticReference]"
              :name="analyticReference" class="form-control form-control-lg"
              v-validate="{regex: /(UA|G|GTM|YT|MO)-\D+\w+/i}"  data-vv-as="Google Analytics Id"/>
            <span v-show="errors.has(`${analyticReference}`)" class="input-error">
              {{ errors.first(`${analyticReference}`) }}
            </span>
          </div>
        </div>
      </div>

      <hr/>

      <div class="form-group">
        <button type="button" class="btn btn-lg btn-primary" v-on:click="validate()">
          Update Analytics Integration
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ShowErrors from '../../common/ShowErrors'

export default {
  name: 'AnalyticsForm',
  components: {
    ShowErrors
  },
  data: function () {
    return {
      availableAnalytics: [],
      analytic: {
        data: {}
      },
      errorMessages: []
    }
  },
  created () {
    this.getAvailableAnalytics()
    this.getAnalyticsIntegration()
  },
  methods: {
    getAvailableAnalytics () {
      var self = this

      this.$http.get('/analytics/available_analytics').then((response) => {
        self.availableAnalytics = response.data.analytics
      })
    },
    getAnalyticsIntegration () {
      var self = this
      var loader = this.$loading.show()

      this.$http.get('/analytics').then((response) => {
        self.analytic = response.data
      }).finally(function () {
        loader.hide()
      })
    },
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.updateAnalyticsConfiguration()
        } else {
          self.$swal({
            title: 'Error saving Analytics Integration',
            text: 'Please, check errors in form',
            type: 'error'
          })
        }
      })
    },
    updateAnalyticsConfiguration () {
      this.errorMessages = []
      var self = this
      var loader = this.$loading.show()
      var analyticId = this.analytic.id

      this.$http.put('/analytics/' + analyticId, { analytic: this.analytic })
        .then((response) => {
          self.analytic = response.data

          self.$swal({
            title: 'Analytics Integration saved!',
            type: 'success'
          })
        }).catch((error) => {
          if (error) {
            var errorMsg = error.response.data.message || error.response.data.error
            self.errorMessages = errorMsg

            self.$swal({
              title: 'Error updating Analytics Integration',
              text: 'Please, check errors in form',
              type: 'error'
            })
          }
        }).finally(() => {
          loader.hide()
        })
    }
  }
}
</script>
